<template>
  <IntContentSection>
    <IntContentContainer>
      <IntContentGrid :columns="{ default: 1, md: 12 }">
        <IntGridColumn :span="{ 'default': 1, md: 5 }" class="md:mb-6 md:order-2">
          <slot name="info"></slot>
        </IntGridColumn>

        <IntGridColumn :span="{ 'default': 1, md: 7 }" class="md:row-span-2 md:order-1">
          <slot name="slider"></slot>
        </IntGridColumn>

        <IntGridColumn :span="{ 'default': 1, md: 5 }" class="md:order-3">
          <slot name="pricing"></slot>
        </IntGridColumn>
      </IntContentGrid>
    </IntContentContainer>
  </IntContentSection>
</template>

<script>
  import IntContentContainer from '../content-container'
  import IntContentGrid from '../content-grid'
  import IntContentSection from '../content-section'
  import IntGridColumn from '../content-grid/grid-column.vue'
  
  export default {
    name: 'IntProductDetail',
    
    components: { IntContentContainer, IntContentGrid, IntContentSection, IntGridColumn }
  }
</script>